import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const tooltipClasses = '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input';

const PermissionsInfoIcon = ({name, onClick, size = 16, zIndex}) => (
    <Tooltip
        title={`View ${name} permissions`}
        placement="top"
        enterDelay={300}
        PopperProps={zIndex ? {style: {zIndex}} : undefined}
        componentsProps={{tooltip: {className: tooltipClasses}}}
    >
        <div
            className="flex items-center justify-center p-1 rounded-menu text-main-light cursor-pointer hover:bg-panels-normal"
            onClick={onClick}
        >
            <InfoOutlinedIcon style={{fontSize: size}} />
        </div>
    </Tooltip>
);

export default PermissionsInfoIcon;
